<section [@fadeIn] id="registerSuccess">
  <img width="57" src="assets/svg/check.svg" alt="" />
  <h1>¡Te registraste con éxito!</h1>
  <nobis-button [routerLink]="['/dashboard/login/exito']">INGRESÁ A LA AUTOGESTIÓN</nobis-button>
</section>

